import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../../../../../../../shared/Button/Button";
import { AVAILABLE_BUTTONS } from "../../../../../../../../api/appointments/useAppointmentQuery";
import { useContext } from "../../context";
import { ButtonQualiphyStatus } from "../../shared/ButtonQualiphyStatus";
import { CalendarCrossIcon } from "../../../../../../../../assets/Icons/CalendarCrossIcon";
import { CreditCardIcon } from "../../../../../../../../assets/Icons/CreditCardIcon";
import { getToken } from "../../../../../../../../Utils/services";
import { useResendInvite } from "../../hooks/useResendInvite";
import { CircularProgress } from "../../../../../../../../shared/CircularProgress/CircularProgress";
import GFEIconV2 from "../../../../../../../../assets/Icons/GFEIconV2";
import { Skeleton } from "../../../../../../../../shared/Skeleton/Skeleton";

const editUrl = (appointmentId) => `/appointment/edit/${appointmentId}`;

export function Header() {
  const { onClose, appointment, gfeToggle, isAppointmentFetching } =
    useContext();
  const resendInvite = useResendInvite();

  const openMeetingUrl = () => {
    if (appointment.meetingUrl) {
      window.open(
        appointment.meetingType === "tokbox"
          ? `${appointment.meetingUrl}/${getToken()}`
          : appointment.meetingUrl,
        "_blank",
      );
    }
  };

  const showGfeIcon = gfeToggle.value !== null;

  const gfeIconColor = () => {
    if (gfeToggle.value === true) {
      return "#03bf62";
    } else {
      if (appointment.gfeExpired) {
        return "#FF0000";
      }
      return "#bcbcbc";
    }
  };

  return (
    <div className="newPopupTitle d-flex flex-col gap-8">
      <div className="d-flex justify-between align-center flex-wrap">
        <div className="d-flex align-center m-b-8">
          <div>Appointment Details</div>
          {appointment.availableButtons.includes(
            AVAILABLE_BUTTONS.editAppointment,
          ) &&
            !appointment.isAdditionalProviderAppointment && (
              <Link
                to={editUrl(appointment.id)}
                className="easy-link edit-event-detail-btn no-padding"
              >
                <i className="fa fa-pencil-alt"></i> Edit
              </Link>
            )}
        </div>
        <div className="d-flex gap-8 m-r-10">
          {appointment.availableButtons.includes(
            AVAILABLE_BUTTONS.joinMeeting,
          ) && (
            <Button size="small" color="success" onClick={openMeetingUrl}>
              Join Meeting
            </Button>
          )}
          {appointment.availableButtons.includes(
            AVAILABLE_BUTTONS.joinMeeting,
          ) && (
            <Button
              size="small"
              onClick={() => resendInvite.initiate(appointment.id)}
              isDisabled={resendInvite.isLoading}
              leftAdornment={
                resendInvite.isLoading ? (
                  <CircularProgress size="tiny" color="white" />
                ) : undefined
              }
            >
              Resend Link
            </Button>
          )}
          {!appointment.isAdditionalProviderAppointment && (
            <ButtonQualiphyStatus />
          )}
        </div>
        <button className="popupClose" onClick={onClose}>
          <img alt="" src="/images/close.png" />
        </button>
      </div>
      <div className="d-flex align-items-center gap-8">
        {(appointment.isCancellationPolicyEnabled ||
          appointment.isDepositCharged) && (
          <div className="d-flex align-items-center gap-8">
            {appointment.isCancellationPolicyEnabled && (
              <div className="text-color-red">
                <CalendarCrossIcon />
              </div>
            )}
            {appointment.isDepositCharged && (
              <div className="text-color-green">
                <CreditCardIcon />
              </div>
            )}
          </div>
        )}
        {showGfeIcon &&
          (isAppointmentFetching ? (
            <Skeleton width="50px" height="30px" />
          ) : (
            <GFEIconV2 color={gfeIconColor()} />
          ))}
      </div>
    </div>
  );
}
